  var lastEmail = '';
  var disabledBtn = true;
  function activeAccount(){

  var inputEmail = document.getElementById('active-email-account');
  var url = "https://journeyapi.amyi.co/api/shopify/search/user?userEmail="+inputEmail.value;
  var content = document.getElementById('content-link');
  var goLink = document.getElementById('goToLinkActive');
  var accountNotFound = document.getElementById('account-not-found');
  var accountHasRegister = document.getElementById('account-has-active');
  var accountSuccess = document.getElementById('active-success');
  var activeError = document.getElementById('active-error');
  var urlToActive = document.getElementById('active-link');
  var waitingMessage = document.getElementById('waiting-link');
    
  if(lastEmail == ''){
    lastEmail = inputEmail.value;
  }

  if(lastEmail != inputEmail.value){
    disabledBtn = false;
  }

  if(urlToActive.href == 'https://amyi.co/pages/ativacao-de-conta' || urlToActive.href == 'https://amyi.co/pages/ativacao-de-conta#'){
    waitingMessage.style.display = 'block';
      fetch(url)
      .then((response) => response.json())
      .then(function(response){
        console.log(response.status)
        if(response.status == 404){
          accountNotFound.style.display = 'block';
          accountHasRegister.style.display = 'none';
          activeError.style.display = 'none';
          accountSuccess.style.display = 'none';
        }
        if(response.status == 201){
          accountHasRegister.style.display = 'block';
          activeError.style.display = 'none';
          accountSuccess.style.display = 'none';
          accountNotFound.style.display = 'none';
        }
        if(response.status == 500){
          activeError.style.display = 'block';
          accountSuccess.style.display = 'none';
          accountHasRegister.style.display = 'none';
          accountNotFound.style.display = 'none'
        }
    
        if(response.status == 200){
          waitingMessage.style.display = 'none';
          urlToActive.style.display = 'flex';
          urlToActive.style.justifyContent = 'center';
          urlToActive.href = response.msg;
          accountSuccess.style.display = 'block';
          accountHasRegister.style.display = 'none';
          accountNotFound.style.display = 'none';
          activeError.style.display = 'none';
        }
        
      });
  }

  
}